/*!
 * Copyright (c) REWE Digital GmbH
 */
import AddShoppingCart from "@material-design-icons/svg/filled/add_shopping_cart.svg";
import ShoppingCart from "@material-design-icons/svg/outlined/shopping_cart.svg";
import ShoppingCartFilled from "@material-design-icons/svg/filled/shopping_cart.svg";
import Favorite from "@material-design-icons/svg/filled/favorite.svg";
import ChevronLeft from "@material-design-icons/svg/filled/chevron_left.svg";
import ChevronRight from "@material-design-icons/svg/filled/chevron_right.svg";
import ContentCopy from "@material-design-icons/svg/filled/content_copy.svg";
import Done from "@material-design-icons/svg/filled/done.svg";
import Add from "@material-design-icons/svg/filled/add.svg";
import Subtract from "@material-design-icons/svg/filled/remove.svg";
import Delete from "@material-design-icons/svg/filled/delete.svg";
import CheckCircle from "@material-design-icons/svg/filled/check_circle.svg";
import Close from "@material-design-icons/svg/filled/close.svg";
import Phone from "@material-design-icons/svg/outlined/phone.svg";
import Mail from "@material-design-icons/svg/filled/mail.svg";
import ArrowDown from "@material-design-icons/svg/filled/keyboard_arrow_down.svg";
import Menu from "@material-design-icons/svg/filled/menu.svg";
import Search from "@material-design-icons/svg/outlined/search.svg";
import Person from "@material-design-icons/svg/outlined/person.svg";
import PersonFilled from "@material-design-icons/svg/filled/person.svg";
import Info from "@material-design-icons/svg/outlined/info.svg";
import Lock from "@material-design-icons/svg/outlined/lock.svg";
import ArrowBack from "@material-design-icons/svg/outlined/arrow_back.svg";
import Timer from "@material-design-icons/svg/outlined/timer.svg";
export const icons = {
    add_shopping_cart: AddShoppingCart,
    shopping_cart: ShoppingCart,
    favorite: Favorite,
    chevron_left: ChevronLeft,
    chevron_right: ChevronRight,
    content_copy: ContentCopy,
    done: Done,
    add: Add,
    subtract: Subtract,
    delete: Delete,
    check_circle: CheckCircle,
    close: Close,
    phone: Phone,
    mail: Mail,
    arrow_down: ArrowDown,
    lock: Lock,
    info: Info,
    menu: Menu,
    search: Search,
    person: Person,
    person_filled: PersonFilled,
    arrow_back: ArrowBack,
    shopping_cart_filled: ShoppingCartFilled,
    timer: Timer,
};
export const iconManager = {
    getIcon: (name) => {
        return icons[name];
    },
};
//# sourceMappingURL=index.js.map
